export default __webpack_public_path__ + "static/media/footerTwitter.198ea001.svg";